import { transformToCdnUrl } from 'utils/google-storage-util';
import base from './tile-art.module.css';
import styles from './HomeDeliveryTileArt.module.css';

export const HomeDeliveryTileArt: React.FC = () => (
    <img
        className={`${base.layer} ${styles.house}`}
        src={transformToCdnUrl('embedded-assets/tiles/home-delivery-tile.webp')}
        width={932}
        height={827}
        alt=""
        aria-hidden="true"
        loading="lazy"
    />
);
